module.exports = __webpack_public_path__ + "img/plan2.1cf09802.jpg";